import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import LandingPage from './pages/LandingPage';
import ParentDashboard from './pages/ParentDashboard';
import ChildDashboard from './pages/ChildDashboard';
import Auth from './pages/Auth';
import TestTaking from './pages/TestTaking';
import Subscription from './pages/Subscription';
import PaymentSuccess from './pages/PaymentSuccess';
import AdminPanel from './pages/AdminPanel';
import TestAdminPanel from './pages/TestAdminPanel';

function App() {
  const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
  };

  const getUserRole = () => {
    const user = localStorage.getItem('user');
    if (user) {
      return JSON.parse(user).role;
    }
    return null;
  };

  const ProtectedRoute = ({ children, allowedRoles }) => {
    if (!isAuthenticated()) {
      return <Navigate to="/auth" />;
    }
    
    const userRole = getUserRole();
    if (allowedRoles && !allowedRoles.includes(userRole)) {
      return <Navigate to="/parent/dashboard" />;
    }
    
    return children;
  };

  const RoleBasedRedirect = () => {
    const userRole = getUserRole();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    
    if (userRole === 'admin') {
      return <Navigate to="/admin" />;
    } else if (userRole === 'test_admin') {
      return <Navigate to="/test-admin" />;
    } else if (userRole === 'child') {
      return <Navigate to={`/child/dashboard/${user.child_id}`} />;
    } else {
      return <Navigate to="/parent/dashboard" />;
    }
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<Auth />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <RoleBasedRedirect />
            </ProtectedRoute>
          }
        />
        <Route
          path="/parent/dashboard"
          element={
            <ProtectedRoute allowedRoles={['parent', 'admin']}>
              <ParentDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/child/dashboard/:childId"
          element={
            <ProtectedRoute allowedRoles={['child', 'parent', 'admin']}>
              <ChildDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/test/:testId"
          element={
            <ProtectedRoute>
              <TestTaking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription"
          element={
            <ProtectedRoute>
              <Subscription />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment-success"
          element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/test-admin"
          element={
            <ProtectedRoute allowedRoles={['test_admin', 'admin']}>
              <TestAdminPanel />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;